module.exports = {
      id: "video-icon-usage",
      viewBox: "0 0 92 92",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#video-icon",
      toString: function () {
        return this.url;
      }
    }